import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const InitializationCalldataSchema = z.object({
  initializationCalldataValue: z.instanceof(HexNumber),
})

type InitializationCalldataProps = z.infer<typeof InitializationCalldataSchema>

export class InitializationCalldata extends ValueObject<InitializationCalldataProps> {
  public getValue(): HexNumber {
    return this.props.initializationCalldataValue
  }

  public static create(
    props: InitializationCalldataProps
  ): InitializationCalldata {
    const validatedProps = InitializationCalldataSchema.parse(props)
    return new InitializationCalldata(validatedProps)
  }
}
